const meta = {
  requiresAdmin: false,
  requiresAuth: true
}

export const routes = [
  {
    path: '/gestao-pagamento',
    component: () => import(/* webpackChunkName: "payment-management" */ './components/List'),
    name: 'management.payment',
    meta
  },
  {
    path: '/gestao-pagamento/usuario/:id',
    component: () => import(/* webpackChunkName: "payment-management" */ './components/ListPayments'),
    name: 'management.payment.user',
    meta
  }
]
